import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import "moment-timezone";

import {styles} from "assets/jss/state-circle.jsx";

import Tooltip from "@material-ui/core/Tooltip";

class StateCircle extends React.Component {

  render() {
    const {classes} = this.props;

    return this.props.detailed ? <span style={{color: this.props.state ? this.props.state.color : "#888888"}}><span className={classes.circle} style={{backgroundColor: this.props.state ? this.props.state.color : "#d6d6d6"}}/>{this.props.state && this.props.state.designation}</span> : <Tooltip
      title={this.props.state && this.props.state.designation}
      placement={this.props.tooltipPlacement || "top-start"}
    >
      <span className={classes.circle} style={{backgroundColor: this.props.state ? this.props.state.color : "#d6d6d6"}}/>
    </Tooltip>;
  }
}

export default withStyles(styles)(StateCircle);
